/**
 * French translations
 */

export default {
  'Enter your email': 'Entrez votre adresse e-mail',
  'Not included': 'Non inclus',
  'Pause video': 'Mettre la vidéo en pause',
  'Play video': 'Lire la vidéo',
  'Pricing plans': 'Plans tarifaires',
  'Select an option': 'Sélectionnez une option',
  'Sign up for GitHub': 'Inscrivez-vous à GitHub',
  Country: 'Pays',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    'Vous avez le droit de refuser la collecte et l’utilisation de vos informations personnelles, l’utilisation de vos informations personnelles à des fins marketing et la réception d’informations marketing comme indiqué ci-dessus. Toutefois, si vous refusez, vous pourriez ne pas être en mesure de bénéficier des avantages décrits dans la section Objet de la collecte et de l’utilisation.',
  'I agree to the collection and use of my personal information (required)*.':
    'J’accepte la collecte et l’utilisation de mes informations personnelles (obligatoire)*.',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    'Éléments d’informations personnelles à collecter : {fields}, et tout autre champ visible sur ce formulaire.',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    'Objet de la collecte et de l’utilisation : GitHub utilisera les données aux fins décrites dans ce formulaire.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    'Période de conservation/utilisation des informations personnelles : aussi longtemps que nécessaire pour fournir le(s) service(s) que vous demandez.',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    'J’accepte de recevoir des informations marketing et l’utilisation de mes informations personnelles à des fins marketing (facultatif).',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    'Consentement à recevoir des communications marketing : les informations collectées peuvent être utilisées par GitHub pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes.',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    'Objet de la collecte et de l’utilisation : vous contacter à des fins marketing.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    'Période de conservation/utilisation des informations personnelles : aussi longtemps que nécessaire pour fournir le(s) service(s) que vous demandez.',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    'Oui, je souhaite que GitHub et ses sociétés affiliées utilisent mes informations pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes. Consultez la',
  'for more details.': 'pour plus de détails.',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    'La participation nécessite le transfert de vos données personnelles vers d’autres pays dans lesquels GitHub opère, y compris les États-Unis. En soumettant ce formulaire, vous acceptez le transfert de vos données en dehors de la Chine.',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    'Je recevrai des communications personnalisées et de la publicité ciblée de la part de GitHub et de ses sociétés affiliées. Consultez la',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Oui, je souhaite recevoir des informations de GitHub et de son groupe d’entreprises par e-mail pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes. Pour retirer votre consentement ou gérer vos préférences de contact, visitez le',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Oui, je souhaite recevoir des informations de GitHub et de son groupe d’entreprises par e-mail et téléphone pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes. Pour retirer votre consentement ou gérer vos préférences de contact, visitez le',
  'Promotional Communications Manager': 'Gestionnaire de communications promotionnelles',
  'GitHub Privacy Statement': 'Déclaration de confidentialité de GitHub',
  'first name': 'prénom',
  'last name': 'nom',
  company: 'entreprise',
  email: 'e-mail',
  'This field is required.': 'Ce champ est obligatoire.',
  'Please enter a valid work email address.': 'Veuillez entrer une adresse e-mail professionnelle valide.',
  'The email is from a personal email provider.':
    'L’adresse e-mail provient d’un fournisseur de messagerie personnelle.',
  'Please enter a valid email address.': 'Veuillez entrer une adresse e-mail valide.',
  'Please enter a valid phone number.': 'Veuillez entrer un numéro de téléphone valide.',
  'Please select your country/region': 'Veuillez sélectionner votre pays/région.',
  'Please complete the CAPTCHA.': 'Veuillez compléter le CAPTCHA.',
  'Choose your country/region': 'Choisissez votre pays/région.',
  Included: 'Inclus',
  Refresh: 'Actualiser',
  Unlimited: 'Illimité',
  'Learn more': 'En savoir plus',
  'Sort by:': 'Trier par :',
  'Selecting a sort option will reload the page.': 'La sélection d’une option de tri rechargera la page.',
  'Sort options': 'Options de tri',
  Sort: 'Trier',
  Newest: 'Plus récent',
  Oldest: 'Plus ancien',
  Whitepaper: 'Livre blanc',
  'Content Type': 'Type de contenu',
  Category: 'Catégorie',
  Whitepapers: 'Livres blancs',
  Ebooks: 'Livres numériques',
  AI: 'IA',
  Cloud: 'Cloud',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: 'Innersource',
  'Open Source': 'Open Source',
  Security: 'Sécurité',
  'Software Development': 'Développement logiciel',
  'Explore other resources': 'Découvrez d’autres ressources',
  Share: 'Partager',
  'Ebooks & Whitepapers': 'Livres numériques et livres blancs',
  Tags: 'Tags',
  Ebook: 'Livre numérique',
  Platform: 'Plateforme',
  'AI CODE CREATION': 'CRÉATION DE CODE PAR IA',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'Améliorez votre code avec l’IA',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': 'Créez et déployez des applications intelligentes',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': 'Gérez et comparez les prompts',
  'MCP Registry (New)': 'MCP Registry (Nouveau)',
  'Integrate external tools': 'Intégrez des outils externes',
  'View all features': 'Voir toutes les fonctionnalités',
  'DEVELOPER WORKFLOWS': 'WORKFLOWS DE DÉVELOPPEMENT',
  Actions: 'Actions',
  'Automate any workflow': 'Automatisez n’importe quel workflow',
  Codespaces: 'Codespaces',
  'Instant dev environments': 'Environnements de développement instantanés',
  Issues: 'Problèmes',
  'Plan and track work': 'Planifiez et suivez le travail',
  'Code review': 'Revue de code',
  'Manage code changes': 'Gérez les modifications de code',
  'APPLICATION SECURITY': 'SÉCURITÉ DES APPLICATIONS',
  'Find and fix vulnerabilities': 'Détectez et corrigez les vulnérabilités',
  'Code Security': 'Code Security',
  'Secure your code as you build': 'Sécurisez votre code dès sa création',
  'Secret Protection': 'Secret Protection',
  'Stop leaks before they start': 'Empêchez les fuites avant qu’elles ne surviennent',
  EXPLORE: 'EXPLORER',
  'Why GitHub': 'Pourquoi GitHub ?',
  Documentation: 'Documentation',
  Blog: 'Blog',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: 'Solutions',
  'BY COMPANY SIZE': 'PAR TAILLE D’ENTREPRISE',
  Enterprises: 'Entreprise',
  'Small and medium teams': 'Petites et moyennes équipes',
  Startups: 'Start-ups',
  Nonprofits: 'Organisations à but non lucratif',
  'View all solutions': 'Voir toutes les solutions',
  'BY USE CASE': 'PAR CAS D’UTILISATION',
  'App modernization': 'Modernisation des applications',
  DevSecOps: 'DevSecOps',
  'View all use cases': 'Voir tous les cas d’utilisation',
  'BY INDUSTRY': 'PAR SECTEUR D’ACTIVITÉ',
  Healthcare: 'Santé',
  'Financial services': 'Services financiers',
  Manufacturing: 'Industrie manufacturière',
  Government: 'Secteur public',
  'View all industries': 'Voir tous les secteurs',
  Resources: 'Ressources',
  'EXPLORE BY TOPIC': 'EXPLORER PAR THÈME',
  'Software development': 'Développement logiciel',
  'View all topics': 'Voir tous les thèmes',
  'EXPLORE BY TYPE': 'EXPLORER PAR TYPE',
  'Customer stories': 'Témoignages clients',
  'Events & webinars': 'Événements et webinaires',
  'Ebooks & reports': 'Ebooks et rapports',
  'Business insights': 'Insights stratégiques',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': 'ASSISTANCE ET SERVICES',
  Customer: 'Assistance client',
  'Customer support': 'Support client',
  'Community forum': 'Forum communautaire',
  'Trust Center': 'Trust Center',
  Partners: 'Partenaires',
  COMMUNITY: 'COMMUNAUTÉ',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': 'Soutenez le développement open source',
  'The ReadME Project': 'The ReadME Project',
  'GitHub community articles': 'Articles de la communauté GitHub',
  'COMMUNITY PROGRAMS': 'PROGRAMMES COMMUNAUTAIRES',
  'Security Lab': 'Security Lab',
  'Maintainer Community': 'Communauté des mainteneurs',
  Accelerator: 'Accélérateur',
  'Archive Program': 'Archive Program',
  REPOSITORIES: 'RÉFÉRENTIELS',
  Topics: 'Thèmes',
  Trending: 'Tendances',
  Collections: 'Collections',
  Enterprise: 'Entreprise',
  'ENTERPRISE SOLUTIONS': 'SOLUTIONS POUR ENTREPRISES',
  'Enterprise platform': 'Plateforme GitHub Enterprise',
  'AI-powered developer platform': 'Plateforme de développement alimentée par l’IA',
  'AVAILABLE ADD-ONS': 'EXTENSIONS DISPONIBLES',
  'Enterprise-grade application security': 'Sécurité des applications niveau entreprise',
  'Copilot for Business': 'Copilot for Business',
  'Enterprise-grade AI features': 'Fonctionnalités IA de niveau entreprise',
  'Premium Support': 'Support Premium',
  'Enterprise-grade 24/7 support': 'Support 24/7 de niveau entreprise',
  New: 'Nouveau',
  Select: 'Sélectionner',
  'Install with script': 'Installer avec un script',
  'Install with npm': 'Installer avec npm',
  'Install with Homebrew': 'Installer avec Homebrew',
  'Install with WinGet': 'Installer avec WinGet',
  Copy: 'Copier',
  'Copy installation command': 'Copier la commande d’installation',
  'Copied to clipboard': 'Copié dans le presse-papiers',
  'Select install method': 'Sélectionnez la méthode d’installation',
  'Get Copilot CLI': 'Obtenir Copilot CLI',
  'Read the documentation.': 'Consultez la documentation.',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'Inclus dans les abonnements Copilot Free, Pro, Pro+, Business et Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'Disponible avec Copilot Free, Pro, Pro+, Business et Enterprise.',
  // Add more translations here
}
